// Function to remove quotes around the win_text span
function removeQuotesFromPopup(span) {
    if (!span) return;

    if (span.previousSibling && span.previousSibling.nodeType === Node.TEXT_NODE) {
        span.previousSibling.textContent = span.previousSibling.textContent.replace(/"$/, '');
    }
    if (span.nextSibling && span.nextSibling.nodeType === Node.TEXT_NODE) {
        span.nextSibling.textContent = span.nextSibling.textContent.replace(/^"/, '');
    }
}

// Initial run in case popup is already in DOM
document.querySelectorAll('.wheelify-text-heading .win_text').forEach(removeQuotesFromPopup);

// Observe body for newly added popups
const observer = new MutationObserver(mutations => {
    mutations.forEach(mutation => {
        mutation.addedNodes.forEach(node => {
            if (node.nodeType === Node.ELEMENT_NODE) {
                // If the node itself is a win_text span
                if (node.matches('.wheelify-text-heading .win_text')) {
                    removeQuotesFromPopup(node);
                }
                // Or if it contains win_text inside
                node.querySelectorAll('.wheelify-text-heading .win_text').forEach(removeQuotesFromPopup);
            }
        });
    });
});

// Start observing
observer.observe(document.body, { childList: true, subtree: true });
